import {
  GET_VIDEO_CONTENT,
  FETCH_START,
  FETCH_SUCCESS,
  FETCH_ERROR,
  SET_PAGE,
  SET_SEARCH,
  SET_PRODUCT_ID,
  SET_ORDER_BY,
  SET_SORT_BY,
  SHOW_MESSAGE,
} from "../../shared/constants/ActionTypes";

import jwtAxios from "@crema/services/auth/jwt-auth/jwt-api";

export const getVideoContent = (limit = 10) => {
  return (dispatch, getState) => {
    const state = getState().videoContent;
    dispatch({ type: FETCH_START });
    jwtAxios
      .post("/module-content/list", {
        search: state.search,
        page: state.page,
        courseId: state.courseId,
        limit,
      })
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: GET_VIDEO_CONTENT,
            payload: data.data.data,
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const addVideoContent = (payload, closeModel, form) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .post("/module-content/add", payload)
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: SHOW_MESSAGE,
            payload: "Module content added successfully.",
          });
          closeModel();
          form.resetFields();
          dispatch(getVideoContent());
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const editVideoContent = (formData, closeModel, form) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .post("/module-content/update-module-content", formData)
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: SHOW_MESSAGE,
            payload: "Module content updated successfully.",
          });
          closeModel();
          form.resetFields();
          dispatch(getVideoContent());
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const updateVideoContentOrder = (payload) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    return jwtAxios
      .post("/module-content/update-order", payload)
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: SHOW_MESSAGE,
            payload: "Order updated successfully.",
          });
          dispatch(getVideoContent());
          return Promise.resolve();
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
          return Promise.reject();
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
        return Promise.reject(error);
      });
  };
};

export const deleteVideoContent = (payload) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .post("/module-content/delete", payload)
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: SHOW_MESSAGE,
            payload: "Module content deleted successfully.",
          });
          dispatch(getVideoContent());
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const deleteAdditionalDocument = (formData) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .post("/module-content/delete-file", formData)
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch(getVideoContent());
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const setPage = (page) => {
  return (dispatch) => {
    dispatch({ type: SET_PAGE, payload: page });
  };
};

export const setSearch = (search) => {
  return (dispatch) => {
    dispatch({ type: SET_SEARCH, payload: search });
  };
};

export const setCourseId = (courseId) => {
  return (dispatch) => {
    dispatch({ type: SET_PRODUCT_ID, payload: courseId });
  };
};
export const setOrderBy = (orderby) => {
  return (dispatch) => {
    dispatch({ type: SET_ORDER_BY, payload: orderby });
  };
};
export const setSortBy = (sortby) => {
  return (dispatch) => {
    dispatch({ type: SET_SORT_BY, payload: sortby });
  };
};
